<template lang='pug'>
section
  s-page-title(title='Управляющие компании')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='ID') {{ props.item.id }}
          td(data-label='Название') {{ props.item.name }}
          td(data-label='Директор') {{ props.item.director }}
          td(data-label='Адрес') {{ props.item.address_full }}
          td(data-label='Контакты')
            template(v-for='contact in parseContacts(props.item.contacts)')
              div(class='wrapless') {{ contact | phone }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '25%',
        sortable: false
      },
      {
        text: 'Директор',
        align: 'left',
        value: 'director',
        width: '20%',
        sortable: false
      },
      {
        text: 'Адрес',
        align: 'left',
        value: 'address_full',
        width: '35%',
        sortable: false
      },
      {
        text: 'Контакты',
        align: 'left',
        value: 'contacts',
        width: '20%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetchList()
  },

  methods: {
    async onDelete(id) {
      if (await this.$confirm('Удалить компанию?')) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$root.showSnack('Ошибка удаления компании')
        }

        this.fetchList()
      }
    },

    onEdit(id) {
      this.$router.push({
        name: 'Admin.ManCompanies.Edit',
        params: { id }
      })
    },

    parseContacts(contacts) {
      try {
        return contacts.split(/,/)
      } catch (e) {
        this.$log.debug(e)
      }
    },

    ...mapActions('admin/manCompanies', ['fetchList', 'destroy'])
  },

  computed: {
    ...mapGetters('admin/manCompanies', ['list', 'isLoading'])
  }
}
</script>
